import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EVENT: {
    SET_NOT_ATTEND_COURSE: (eventId, callback) => ({ eventId, callback }),
    API: {
      SET_NOT_ATTEND_COURSE: apiResourceActionCreator('notAttendCourse')
    }
  }
})

export const apiAction = (authToken, eventId) => commonApiActions.authenticated.post(`${API_ENDPOINT}/setNotAttendCourse/${eventId}`, authToken, {}, action.event.api.setNotAttendCourse)

function* setNotAttendCourse({ payload }) {
  const authToken = yield select(authTokenSelector);

  const { eventId, callback } = payload;

  yield put(apiAction(authToken, eventId));

  const setNotAttendCourseResult = yield apiActionResult(action.event.api.setNotAttendCourse);

  if (setNotAttendCourseResult.success) {
    if (callback) {
      callback()
    }
  }
}

const configuration = {
  name: 'setNotAttendCourse',
  action: action,
  sagas: setNotAttendCourse,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/event/configurations/setNotAttendCourse.js